import { cn } from "@nexus/ui";
import { useTranslation } from "react-i18next";

import { describeSetDateWindow } from "../../../lib/set-date-window-display";

import type { ExtraRollingPresetMatch } from "@/features/dashboard/lib/explore-date-presets";

export interface SetDateWindowMetaProps {
  startDate?: string | Date | null;
  endDate?: string | Date | null;
  extraRollingPresets?: readonly ExtraRollingPresetMatch[];
  today?: Date;
  className?: string;
}

export function SetDateWindowMeta({
  startDate,
  endDate,
  extraRollingPresets,
  today,
  className,
}: SetDateWindowMetaProps) {
  const { t } = useTranslation();
  const display = describeSetDateWindow(startDate, endDate, t, extraRollingPresets, today);
  if (!display) return null;

  return (
    <div className={cn("flex min-w-0 flex-col gap-0.5", className)}>
      <span
        className="inline-flex w-fit max-w-full items-center truncate rounded-md bg-muted/70 px-1.5 py-0.5 text-[10px] font-medium leading-tight text-muted-foreground/80"
        title={`${display.presetLabel} · ${display.rangeLabel}`}
      >
        {display.presetLabel}
      </span>
      <span className="truncate text-[11px] leading-tight text-muted-foreground/55">
        {display.rangeLabel}
      </span>
    </div>
  );
}
